import * as React from 'react';

function SvgChevronBack(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.643 2.266a.91.91 0 010 1.286L9.195 12l8.448 8.448a.91.91 0 01-1.286 1.286l-9.09-9.091a.909.909 0 010-1.286l9.09-9.09a.909.909 0 011.286 0z", clipRule: "evenodd" })));
}

export default SvgChevronBack;
